"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarDatePicker = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const StaticDatePicker_1 = __importDefault(require("@opsbase/web-pickers/DatePicker/StaticDatePicker"));
const react_1 = __importStar(require("react"));
const useOpScheduleCalendar_1 = __importDefault(require("../OpScheduleCalendarController/useOpScheduleCalendar"));
const useOpScheduleCalendarActions_1 = __importDefault(require("../OpScheduleCalendarController/useOpScheduleCalendarActions"));
const makeMyClasses = selectedDates => {
    return {
        root: {
            [selectedDates.map(d => `& button[aria-label="${d}"]`).join(', ')]: {
                backgroundColor: `${lib_palette_1.default.Platinum.main} !important`,
                color: `${lib_palette_1.default.Platinum.contrastText} !important`,
                boxShadow: `0 0 10px -4px ${lib_palette_1.default.BlackCoral.main}`,
            },
            '& .Mui-selected': {
                backgroundColor: `${lib_palette_1.default.Platinum.main} !important`,
                color: `${lib_palette_1.default.Platinum.contrastText} !important`,
                boxShadow: `0 0 10px -4px ${lib_palette_1.default.BlackCoral.main}`,
            },
        },
    };
};
const CalendarDatePicker = function () {
    const { date, calendarView } = (0, useOpScheduleCalendar_1.default)();
    const { doChangeDate } = (0, useOpScheduleCalendarActions_1.default)();
    const selectedDates = calcSelectedDates(date, calendarView);
    const myCss = (0, web_css_1.default)(makeMyClasses, [selectedDates]);
    return (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: myCss.root },
        react_1.default.createElement(StaticDatePicker_1.default, { pickOnYearChange: true, pickOnMonthChange: true, value: date, onChange: doChangeDate }))), [myCss, date, doChangeDate]);
};
exports.CalendarDatePicker = CalendarDatePicker;
exports.default = exports.CalendarDatePicker;
function calcSelectedDates(d, calendarView) {
    const currDate = d.clone().startOf(calendarView).startOf('day');
    const lastDate = d.clone().endOf(calendarView).endOf('day');
    const dates = [currDate.format('D MMM YYYY')];
    while (currDate.add(1, 'days').diff(lastDate) < 0) {
        dates.push(currDate.format('D MMM YYYY'));
    }
    return dates;
}
